export const PLAN_RANK = { free: 0, basic: 1, premium: 2 };

export const PLAN_LABEL = { free: "Gratuit", basic: "Basique", premium: "Premium" };

// Plan minimum requis par section
export const ROUTE_MIN_PLAN = {
  "/dashboard": "basic",
  "/news": "basic",
  "/calendrier": "free",
  "/macro-overview": "premium",
  "/agent": "premium",
  "/macro": "premium",
  "/donnees": "premium",
};

export function isAdmin(user) {
  return user && (user.role === "admin" || user.role === "superadmin");
}

export function hasAccess(user, minPlan) {
  if (!user) return false;
  if (isAdmin(user)) return true;
  return PLAN_RANK[user.plan || "free"] >= PLAN_RANK[minPlan];
}
